import { Pages } from '~/lib/data-contract';
import { getDynamicPage } from './utils/getDynamicPage';

export type DynamicPageProps = {
    page: Pages;
};

export const DynamicPage = (props: DynamicPageProps) => {
    const { page } = props;

    const Page = getDynamicPage(page.type);

    return <Page page={page} {...page} />;
};
